import { render, staticRenderFns } from "./UserRolesForm.vue?vue&type=template&id=3548b5e6&scoped=true&"
import script from "./UserRolesForm.vue?vue&type=script&lang=js&"
export * from "./UserRolesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3548b5e6",
  null
  
)

export default component.exports